import { FeatureFlag, useFeatureFlag } from "../contexts/launchDarklyContext";

/**
 * Whether the "Sign in with Optro" entry point is enabled for the current
 * user/workspace.
 *
 * Single source of truth for the sign-in surface so the button (and its domain
 * dialog) can't drift out of sync. The backend gates the Optro OAuth endpoints
 * on the same `sign-in-with-optro` LaunchDarkly flag.
 *
 * Fails closed (off) until flags resolve or when LaunchDarkly is unconfigured.
 * Targeting is managed in the LaunchDarkly dashboard.
 */
export function useSignInWithOptroEnabled(): boolean {
  return useFeatureFlag(FeatureFlag.signInWithOptro);
}
